import { useUserState } from "@gx1/gx-npm-lib";
import { useSearchParams } from "react-router";
import { useTrackParams } from "./use-track-params.hook";
import { isValidAppRoute } from "../lib";

export const useRedirect = () => {
  const { hasTasks, hasInitiatives, isEntitled } = useUserState();
  const [searchParams] = useSearchParams({ redirect: "" });
  const { trackParams } = useTrackParams();
  const isSurveyRecipient = hasTasks && !hasInitiatives && !isEntitled;
  const { redirect, redirectSearchParams } = (() => {
    const redirectParam = searchParams.get("redirect");
    if (!redirectParam) {
      return { redirect: "", redirectSearchParams: {} };
    }
    const decodedRedirect = decodeURI(redirectParam);
    if (!isValidAppRoute(decodedRedirect)) {
      return { redirect: "", redirectSearchParams: {} };
    }
    const decodedRedirectSplit = decodedRedirect.split("?");
    return {
      redirect: decodedRedirectSplit[0],
      redirectSearchParams: Object.fromEntries(new URLSearchParams(decodedRedirectSplit[1]))
    };
  })();
  const finalSearchParams = (redirect
    ? new URLSearchParams({ ...redirectSearchParams, ...trackParams })
    : new URLSearchParams(trackParams)).toString();
  const finalQueryString = finalSearchParams ? `?${finalSearchParams}` : "";
  const finalRedirect = redirect
    ? `${redirect}${finalQueryString}`
    : isSurveyRecipient ? `/s/tasks${finalQueryString}` : `/s/home${finalQueryString}`;
  return { redirect: finalRedirect };
};